<div mat-dialog-title>
  <h2 class="my-0">
    {{ 'map.export_dxf.name' | translate }}
  </h2>
</div>
<div mat-dialog-content>
  <div class="container-fluid py-3">
    <div class="row" class="d-flex justify-content-center gap-3">
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label> {{ 'map.export_dxf.title' | translate }}</mat-label>
          <input matInput [(ngModel)]="dxfTitle" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-label *ngIf="this.dxfService.dxfAreaSelected" class="d-flex flex-column justify-content-start align-items-center">
          <span>{{ 'map.export_dxf.geometry_selected' | translate }}</span>
          <span class="material-symbols-outlined">check</span>
        </mat-label>
        <mat-label *ngIf="!this.dxfService.dxfAreaSelected" class="d-flex flex-column justify-content-start align-items-center">
          <span>{{ 'map.export_dxf.geometry_not_selected' | translate }}</span>
          <span class="material-symbols-outlined">close</span>
        </mat-label>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button color="primary" class="mx-2 float-right" (click)="selectAreaClick()">
    <span>{{ 'map.export_dxf.select_area' | translate }}</span>
    <mat-icon
      aria-hidden="false"
      aria-label="Example home icon"
      fontIcon="highlight_alt"
      class="select-area-icon"
    ></mat-icon>
  </button>
  <button mat-stroked-button [mat-dialog-close]="false" color="primary" class="mx-2">
    {{ 'common.close' | translate }}
  </button>
  <button mat-flat-button color="primary" class="mx-2" (click)="onSave()" [disabled]="!dxfTitle">
    {{ 'common.save' | translate }}
  </button>
</div>
